import { Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import { modalTheme } from '../../helpers/contents';
import { Button } from './../index';
const MConfirmation = ({
  setOpenModal,
  openModal,
  icon,
  title,
  showFooter = false,
  content,
  confirm,
  loading,
  singleButton = false,
  titleButton,
  disabled = false
}) => {
  const { t } = useTranslation();
  return (
    <Modal theme={modalTheme} show={openModal}>
      <div className="flex flex-row items-center p-5">
        <FaTimes
          className="bg-[#00CEBC] text-white text-[20px] rounded-[5px] cursor-pointer"
          onClick={() => setOpenModal(false)}
        />
        <div className="mx-auto text-[#3E0292] font-bold text-[16px]">
          {title}
        </div>
      </div>
      <Modal.Body>{content}</Modal.Body>
      {showFooter ? (
        <Modal.Footer>
          {singleButton ? (
            <div className="flex flex-row items-center justify-center w-[100%]">
              <Button
                loading={loading}
                dark={false}
                title={titleButton}
                className="bg-[#00CEBC] border-[#00CEBC] w-[50%]"
                onClick={confirm}
              />
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center w-[100%]">
              <Button
                loading={loading}
                dark={false}
                title={t('mConfirmation.confirm')}
                className="bg-[#00CEBC] border-[#00CEBC] mx-2 w-[30%]"
                onClick={confirm}
                disabled={disabled}
              />
              <Button
                dark={false}
                title={t('mConfirmation.cancel')}
                className="bg-[#ffffff] border-[#00CEBC] text-[#00CEBC] w-[30%]"
                textColor="#00CEBC"
                onClick={() => setOpenModal(false)}
              />
            </div>
          )}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default MConfirmation;
